module.exports = __webpack_public_path__ + "assets/house-visit.11a4e20c.png";